import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from '@mui/material'
import { useFormik } from 'formik'

type TagDialogProps = {
  tag?: {
    id: string
    name: string
  }
  open: boolean
  submitLabel?: string
  onClose: () => void
  onSubmit?: (data: any) => void
}

const TagDialog: React.FC<TagDialogProps> = ({
  tag,
  open,
  submitLabel,
  onClose,
  onSubmit,
}) => {
  const formik = useFormik({
    initialValues: {
      name: tag?.name ?? '',
    },
    onSubmit: async (values) => {
      onSubmit?.(values)
    },
  })

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label="Name"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button type="button" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit">{submitLabel ?? 'Submit'}</Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default TagDialog
